

(function (window) {

    var mobileDropdownEl = function () {
        var menuStack = [];
        var ui = {};
        var isMobile;
        var SHOW_CSS = '-open';
        var MEDIA_QUERY = '(max-width: 767px)';
        var mql = window.matchMedia(MEDIA_QUERY);

        function cacheUI() {
            ui.$body = $('body');
            ui.tigger = $('[data-control="mobile-dropdown-trigger"]');
            ui.dropdown = $('[data-region="mobile-dropdown-list"]');
        }

        function toggleMobileDropdown(e) {
            e.preventDefault();
            var $target = $(e.target);
            var parent = $(e.target).closest('[data-region="mobile-dropdown"]');

            if($(e.target).hasClass(SHOW_CSS)) {
                $target.removeClass(SHOW_CSS);
                $(parent).find(ui.dropdown).removeClass(SHOW_CSS);
            }else {
                $target.addClass(SHOW_CSS);
                $(parent).find(ui.dropdown).addClass(SHOW_CSS);
            }
        }


        function bindEvents() {
            ui.tigger.on('click', toggleMobileDropdown);
        }

        function init() {
            cacheUI();
            bindEvents();
        }

        return {
            init: init
        };
    };

    var mobileDropdown = mobileDropdownEl();
    mobileDropdown.init();
})(window);
